(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[495],{

/***/ 42003:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
// This icon file is generated automatically.
var EyeInvisibleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { "tag": "path", "attrs": { "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, "name": "eye-invisible", "theme": "outlined" };
/* harmony default export */ __webpack_exports__["Z"] = (EyeInvisibleOutlined);


/***/ }),

/***/ 5717:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
// This icon file is generated automatically.
var EyeOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, "name": "eye", "theme": "outlined" };
/* harmony default export */ __webpack_exports__["Z"] = (EyeOutlined);


/***/ }),

/***/ 50675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ant_design_icons_svg_es_asn_CheckCircleFilled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72961);
/* harmony import */ var _components_AntdIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89099);

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY



var CheckCircleFilled = function CheckCircleFilled(props, ref) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_AntdIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props), {}, {
    ref: ref,
    icon: _ant_design_icons_svg_es_asn_CheckCircleFilled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
  }));
};
CheckCircleFilled.displayName = 'CheckCircleFilled';
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(CheckCircleFilled));

/***/ }),

/***/ 54722:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return __webpack_require__(85323);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47741);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35656);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);




function AuthSocialLogin() {
    // use i18n
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)([
        "auth"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                mb: 3,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                    as: "a",
                    colorScheme: "facebook",
                    width: "100%",
                    href: "".concat("https://api.lamptan.co.th", "/v1/auth/facebook"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .HStack */ .Ug, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Center */ .M5, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "/image-icon/login-fb.png",
                                    alt: "facebook",
                                    width: 22,
                                    height: 22,
                                    quality: 100
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                                children: t("auth.form.social.loginWithFacebook", {
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                    as: "a",
                    variant: "outline",
                    colorScheme: "gray",
                    border: "1px solid",
                    borderColor: "gray.200",
                    width: "100%",
                    _hover: {
                        bg: "gray.50"
                    },
                    href: "".concat("https://api.lamptan.co.th", "/v1/auth/google"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .HStack */ .Ug, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Center */ .M5, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "/image-icon/login-google.png",
                                    alt: "google",
                                    width: 24,
                                    height: 24,
                                    quality: 100
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                                children: t("auth.form.social.loginWithGoogle", {
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AuthSocialLogin);


/***/ }),

/***/ 26430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83234);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9135);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87536);




function InputCheckboxGroup(param) {
    let { name , label , placeholder , description , control , rules , watch , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .Controller */ .Qr, {
        control: control,
        render: (param)=>{
            let { field: { onChange , value  } , formState: { errors  }  } = param;
            var _errors_name, _errors_name1;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .FormControl */ .NI, {
                isInvalid: name in errors,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Checkbox */ .XZ, {
                        ...rest,
                        value: value !== null && value !== void 0 ? value : "",
                        isChecked: value,
                        onChange: (val)=>onChange(val),
                        children: label
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .FormHelperText */ .Q6, {
                        children: description
                    }),
                    ((_errors_name = errors[name]) === null || _errors_name === void 0 ? void 0 : _errors_name.message) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .FormErrorMessage */ .J1, {
                        mt: 1,
                        children: (_errors_name1 = errors[name]) === null || _errors_name1 === void 0 ? void 0 : _errors_name1.message
                    })
                ]
            });
        },
        name: name,
        rules: rules
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (InputCheckboxGroup);


/***/ }),

/***/ 80929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ inputs_InputTextGroup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons-svg/es/asn/EyeInvisibleOutlined.js
var asn_EyeInvisibleOutlined = __webpack_require__(42003);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 5 modules
var AntdIcon = __webpack_require__(89099);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/EyeInvisibleOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY



var EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_EyeInvisibleOutlined/* default */.Z
  }));
};
EyeInvisibleOutlined.displayName = 'EyeInvisibleOutlined';
/* harmony default export */ var icons_EyeInvisibleOutlined = (/*#__PURE__*/react.forwardRef(EyeInvisibleOutlined));
// EXTERNAL MODULE: ./node_modules/@ant-design/icons-svg/es/asn/EyeOutlined.js
var asn_EyeOutlined = __webpack_require__(5717);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/EyeOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY



var EyeOutlined = function EyeOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_EyeOutlined/* default */.Z
  }));
};
EyeOutlined.displayName = 'EyeOutlined';
/* harmony default export */ var icons_EyeOutlined = (/*#__PURE__*/react.forwardRef(EyeOutlined));
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/index.esm.js
var index_esm = __webpack_require__(83234);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var dist_index_esm = __webpack_require__(20979);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var react_hook_form_dist_index_esm = __webpack_require__(87536);
;// CONCATENATED MODULE: ./components/inputs/InputTextGroup.tsx






function InputTextGroup(param) {
    let { name , label , type , placeholder , description , control , rules , watch , ...rest } = param;
    const [passwordShown, setPasswordShown] = react.useState(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_hook_form_dist_index_esm/* Controller */.Qr, {
        control: control,
        render: (param)=>{
            let { field: { onChange , value  } , formState: { errors  }  } = param;
            var _get, _get1, _get2, _get3;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(index_esm/* FormControl */.NI, {
                isInvalid: ((_get = (0,lodash.get)(errors, name)) === null || _get === void 0 ? void 0 : _get.message) !== "" && ((_get1 = (0,lodash.get)(errors, name)) === null || _get1 === void 0 ? void 0 : _get1.message) !== undefined,
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormLabel */.lX, {
                        mb: 1,
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* InputGroup */.BZ, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                ...rest,
                                type: type ? type === "password" ? passwordShown ? "text" : "password" : type : "text",
                                name: name,
                                placeholder: placeholder,
                                onChange: (val)=>onChange(val),
                                value: value !== null && value !== void 0 ? value : ""
                            }),
                            type === "password" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* InputRightElement */.xH, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                    size: "sm",
                                    onClick: ()=>{
                                        setPasswordShown(!passwordShown);
                                    },
                                    variant: "unstyled",
                                    paddingLeft: 2,
                                    paddingRight: 4,
                                    minWidth: "auto",
                                    children: passwordShown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_EyeInvisibleOutlined, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_EyeOutlined, {})
                                })
                            })
                        ]
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormHelperText */.Q6, {
                        children: description
                    }),
                    ((_get2 = (0,lodash.get)(errors, name)) === null || _get2 === void 0 ? void 0 : _get2.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormErrorMessage */.J1, {
                        mt: 1,
                        children: (_get3 = (0,lodash.get)(errors, name)) === null || _get3 === void 0 ? void 0 : _get3.message
                    })
                ]
            });
        },
        name: name,
        rules: rules
    });
}
/* harmony default export */ var inputs_InputTextGroup = (InputTextGroup);


/***/ }),

/***/ 64070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ page_header_PageHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/breadcrumb/dist/index.esm.js
var dist_index_esm = __webpack_require__(73238);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/breadcrumb/AppBreadcrumb.tsx





function AppBreadcrumb(param) {
    let { breadcrumb  } = param;
    // use router
    const { pathname  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Breadcrumb */.aG, {
            separator: ">",
            color: "gray.600",
            className: "app-breadcrumb",
            children: breadcrumb.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* BreadcrumbItem */.gN, {
                    isCurrentPage: pathname === item.href,
                    children: item.href ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: item.href,
                        passHref: true,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* BreadcrumbLink */.At, {
                            children: item.label
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        noOfLines: 1,
                        children: item.label
                    })
                }, index))
        })
    });
}
/* harmony default export */ var breadcrumb_AppBreadcrumb = (AppBreadcrumb);

;// CONCATENATED MODULE: ./components/page-header/PageHeader.tsx




function PageHeader(param) {
    let { title , breadcrumb , backLink , containerMaxWidth ="850px"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                borderBottom: "1px solid",
                borderColor: "primary.400",
                pt: 8,
                pb: 4,
                bgGradient: "linear(to-t, white 55%, #ffd5b1 100%)",
                display: {
                    base: "none",
                    lg: "block"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                    maxWidth: containerMaxWidth,
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            color: "gray.600",
                            fontWeight: "300",
                            fontSize: "lg",
                            children: title
                        }),
                        breadcrumb && breadcrumb.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            fontSize: "lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb_AppBreadcrumb, {
                                breadcrumb: breadcrumb
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                py: 2,
                display: {
                    base: "block",
                    lg: "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            color: "gray.600",
                            fontWeight: "300",
                            fontSize: "md",
                            children: title
                        }),
                        breadcrumb && breadcrumb.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb_AppBreadcrumb, {
                            breadcrumb: breadcrumb
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var page_header_PageHeader = (PageHeader);


/***/ }),

/***/ 61053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47741);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);





function PageTitleMobile(param) {
    let { children , backLink  } = param;
    // use router
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
        bg: "#F36621",
        height: "32px",
        display: {
            lg: "none"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W2, {
            h: "100%",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .HStack */ .Ug, {
                color: "white",
                h: "100%",
                children: [
                    backLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
                        variant: "unstyled",
                        minW: "auto",
                        minHeight: "auto",
                        onClick: ()=>{
                            router.push(backLink, backLink, {
                                locale: router.locale
                            });
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: "/image-icon/arrow-prev-white.png",
                            width: 9,
                            height: 12,
                            alt: "next"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
                        fontSize: "17px",
                        fontWeight: "400",
                        color: "white",
                        children: children
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PageTitleMobile);


/***/ }),

/***/ 23440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70594);

// Set config defaults when creating the instance
const _axiosAdmin = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create({
    baseURL: "https://api.lamptan.co.th"
});
_axiosAdmin.defaults.headers.common.Authorization = "";
// Add a request interceptor
_axiosAdmin.interceptors.request.use(function(config) {
    if (config.headers) {
        config.headers["x-custom-lang"] = "th";
    }
    ;
    ;
    return config;
}, function(error) {
    return Promise.reject(error);
});
_axiosAdmin.interceptors.response.use(function(response) {
    ;
    return response;
});
/* harmony default export */ __webpack_exports__["Z"] = (_axiosAdmin);


/***/ }),

/***/ 85323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ register; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CheckCircleFilled.js
var CheckCircleFilled = __webpack_require__(50675);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/antd/es/notification/index.js
var notification = __webpack_require__(26855);
// EXTERNAL MODULE: ./components/inputs/InputTextGroup.tsx + 2 modules
var InputTextGroup = __webpack_require__(80929);
// EXTERNAL MODULE: ./components/inputs/InputCheckboxGroup.tsx
var InputCheckboxGroup = __webpack_require__(26430);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(35656);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var react_hook_form_dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./components/auth/AuthSocialLogin.tsx
var AuthSocialLogin = __webpack_require__(97817);
;// CONCATENATED MODULE: ./components/auth/AuthRegisterForm.tsx







function AuthRegisterForm(param) {
    let { loading , onSubmit  } = param;
    // use i18n
    const { t  } = (0,esm/* useTranslation */.$G)([
        "auth",
        "common"
    ]);
    // use react-hook-form
    const { control , watch , handleSubmit  } = (0,react_hook_form_dist_index_esm/* useForm */.cI)({
        mode: "onBlur"
    });
    // watch confirm new password
    const watchPassword = watch("password", "");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            onSubmit: handleSubmit(onSubmit),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputTextGroup/* default */.Z, {
                            name: "firstName",
                            label: t("form.label.firstName", {
                                // TH: ชื่อ
                                // EN: First name
                                ns: "common"
                            }),
                            control: control,
                            rules: {
                                required: {
                                    value: true,
                                    message: t("form.message.required", {
                                        ns: "common"
                                    })
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputTextGroup/* default */.Z, {
                            name: "lastName",
                            label: t("form.label.lastName", {
                                // TH: นามสกุล
                                // EN: Last name
                                ns: "common"
                            }),
                            control: control,
                            rules: {
                                required: {
                                    value: true,
                                    message: t("form.message.required", {
                                        ns: "common"
                                    })
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputTextGroup/* default */.Z, {
                            name: "email",
                            label: t("form.label.email", {
                                // TH: อีเมล
                                // EN: Email
                                ns: "common"
                            }),
                            control: control,
                            rules: {
                                required: {
                                    value: true,
                                    message: t("form.message.required", {
                                        ns: "common"
                                    })
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputTextGroup/* default */.Z, {
                            name: "mobileNumber",
                            label: t("form.label.mobileNumber", {
                                // TH: เบอร์โทรศัพท์
                                // EN: Mobile number
                                ns: "common"
                            }),
                            control: control,
                            type: "tel",
                            rules: {
                                required: {
                                    value: true,
                                    message: t("form.message.required", {
                                        ns: "common"
                                    })
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputTextGroup/* default */.Z, {
                            name: "password",
                            type: "password",
                            label: t("form.label.password", {
                                ns: "common"
                            }),
                            control: control,
                            rules: {
                                required: {
                                    value: true,
                                    message: t("form.message.required", {
                                        ns: "common"
                                    })
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputTextGroup/* default */.Z, {
                            name: "confirmPassword",
                            type: "password",
                            label: t("form.label.confirmPassword", {
                                ns: "common"
                            }),
                            control: control,
                            rules: {
                                required: {
                                    value: true,
                                    message: t("form.message.required", {
                                        ns: "common"
                                    })
                                },
                                validate: (value)=>value === watchPassword || t("form.message.passwordNotMatch", {
                                        ns: "common"
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputCheckboxGroup/* default */.Z, {
                            name: "subscribe",
                            label: t("auth.register.emailNewsletter"),
                            control: control,
                            rules: {}
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                            fontSize: "sm",
                            mb: 2,
                            children: t("auth.register.agreement")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                            type: "submit",
                            bg: "black",
                            width: "100%",
                            isLoading: loading,
                            children: t("auth.register.button", {
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                        children: t("auth.form.social.divider")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthSocialLogin/* default */.Z, {})
                ]
            })
        })
    });
}
/* harmony default export */ var auth_AuthRegisterForm = (AuthRegisterForm);

// EXTERNAL MODULE: ./components/page-header/PageHeader.tsx + 1 modules
var PageHeader = __webpack_require__(64070);
// EXTERNAL MODULE: ./components/page-header/PageTitleMobile.tsx
var PageTitleMobile = __webpack_require__(61053);
// EXTERNAL MODULE: ./hooks/useCatchError.ts
var useCatchError = __webpack_require__(65633);
// EXTERNAL MODULE: ./layouts/RootLayout.tsx + 10 modules
var RootLayout = __webpack_require__(89806);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./respository/auth.repository.ts
var auth_repository = __webpack_require__(71219);
// EXTERNAL MODULE: ./respository/newsletter.repository.ts
var newsletter_repository = __webpack_require__(70625);
;// CONCATENATED MODULE: ./pages/register.tsx















const RegisterPage = ()=>{
    // use i18n
    const { t  } = (0,esm/* useTranslation */.$G)([
        "auth"
    ]);
    // use notification
    const [api, contextHolder] = notification/* default.useNotification */.Z.useNotification();
    const [isMobile] = (0,index_esm/* useMediaQuery */.ac)("(max-width: 767px)");
    const [isDesktop] = (0,index_esm/* useMediaQuery */.ac)("(min-width: 1024px)");
    // use catch error
    const catchError = (0,useCatchError/* default */.Z)();
    // init isSubmitting state
    const [isSubmitting, setIsSubmitting] = (0,react.useState)(false);
    // init is register complete state
    const [isRegisterComplete, setIsRegisterComplete] = (0,react.useState)(false);
    // handle submit
    const handleSubmit = async (values)=>{
        try {
            setIsSubmitting(true);
            // store subscribe preference
            const shouldSubscribe = values.subscribe;
            // remove confirm password and subscribe from registration data
            delete values.confirmPassword;
            delete values.subscribe;
            await auth_repository/* AuthRepository.userRegister */.O.userRegister(values);
            // if user wants to subscribe to newsletter, call the newsletter API
            if (shouldSubscribe) {
                try {
                    await newsletter_repository/* NewsletterRepository.subscribe */.I.subscribe({
                        email: values.email,
                        firstName: values.firstName,
                        lastName: values.lastName,
                        tags: [
                            "registration-form",
                            "new-user"
                        ]
                    });
                } catch (newsletterError) {
                    ;
                }
            }
            setIsRegisterComplete(true);
            api.success({
                message: t("auth.register.complete.title", {
                }),
                description: t("auth.register.complete.goToLogin", {
                })
            });
        } catch (error) {
            catchError(error);
        } finally{
            setIsSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            contextHolder,
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: t("auth.register.title", {
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                        title: t("auth.register.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitleMobile/* default */.Z, {
                        children: t("auth.login.welcomeTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Container */.W2, {
                        children: [
                            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                as: "h2",
                                fontSize: "22px",
                                fontWeight: 400,
                                mt: 10,
                                mb: 6,
                                children: t("auth.register.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                                pt: {
                                    base: 4,
                                    md: 0
                                },
                                pb: {
                                    base: 8,
                                    md: 14
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                    width: "450px",
                                    children: isRegisterComplete ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Center */.M5, {
                                        flexDirection: "column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                fontSize: "6xl",
                                                color: "green",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleFilled/* default */.Z, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                                fontSize: "2xl",
                                                mb: 2,
                                                children: t("auth.register.complete.title", {
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                mb: 4,
                                                textAlign: "center",
                                                children: t("auth.register.complete.goToLogin", {
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/login",
                                                passHref: true,
                                                legacyBehavior: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                    as: "a",
                                                    bg: "gray.800",
                                                    minW: "160px",
                                                    children: t("auth.login.title")
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                mt: {
                                                    base: 0,
                                                    md: 10,
                                                    lg: 0
                                                },
                                                mb: 4,
                                                alignItems: "flex-end",
                                                justifyContent: "space-between",
                                                display: {
                                                    base: "none",
                                                    md: "flex"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                                        as: "h2",
                                                        fontSize: "2xl",
                                                        fontWeight: 400,
                                                        children: t("auth.register.wellcomeTitle", {
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                                        children: [
                                                            t("auth.register.haveAnAccount", {
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/login",
                                                                passHref: true,
                                                                legacyBehavior: true,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                                    variant: "link",
                                                                    as: "a",
                                                                    children: t("auth.login.title")
                                                                })
                                                            }),
                                                            " ",
                                                            t("auth.register.haveAnAccountHere", {
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_AuthRegisterForm, {
                                                    onSubmit: handleSubmit,
                                                    loading: isSubmitting
                                                })
                                            }),
                                            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                height: "1px",
                                                my: 6,
                                                bg: "gray.100"
                                            }),
                                            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                                                height: "100%",
                                                bg: "#EADECE",
                                                p: !isDesktop ? 6 : 0,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                                                    textAlign: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                                            as: "h2",
                                                            mb: 4,
                                                            children: t("auth.register.haveAnAccount")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/login",
                                                            passHref: true,
                                                            legacyBehavior: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                                as: "a",
                                                                bg: "gray.800",
                                                                minWidth: "150px",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                            color: "primary.500",
                                                                            children: t("auth.login.title")
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                            children: t("auth.register.haveAnAccountHere")
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
RegisterPage.getLayout = (page)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(RootLayout/* default */.Z, {
        children: page
    });
var __N_SSP = true;
/* harmony default export */ var register = (RegisterPage);


/***/ }),

/***/ 71219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ AuthRepository; }
/* harmony export */ });
/* harmony import */ var libs_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64232);
/* harmony import */ var libs_axios_admin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23440);


class AuthRepository {
    static administratorLogin(body) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios_admin__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/v1/auth/admin/login", body);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static sendResetPassword(body) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/v1/auth/send-reset-password", body);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static resetPassword(body) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios_admin__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/v1/auth/reset-password", body);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static administratorSendResetPassword(body) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios_admin__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/v1/auth/admin/send-reset-password", body);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static administratorResetPassword(body) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios_admin__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/v1/auth/admin/reset-password", body);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static async userLogin(body) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/v1/auth/login", body);
                // set axios token after login
                libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].defaults.headers.common.Authorization */ .Z.defaults.headers.common.Authorization = "Bearer ".concat(data.accessToken);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static async userRegister(body) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/v1/auth/register", body);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    constructor(){}
}


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,8641,5675,1664,3863,7903,5359,2134,2077,6602,7001,9806,9774,2888,179], function() { return __webpack_exec__(54722); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);